import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

const Coaching = () => {
  return (
    <div className="min-h-screen pt-32">
      {/* Hero */}
      <section className="py-20">
        <div className="container-custom">
          <h1 className="heading-1 mb-8">PRIVATE COACHING</h1>
          <p className="body-large max-w-3xl">
            Limited, application-based coaching with Mel Masry for serious practitioners.
          </p>
        </div>
      </section>

      {/* Overview */}
      <section className="py-20 bg-card">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <h2 className="heading-2 mb-8">STRUCTURE</h2>
            <p className="body-medium mb-6">
              Private coaching is reserved for professional actors, established coaches, and practitioners requiring individualized guidance in the GPS Method™.
            </p>
            <p className="body-medium mb-6 text-secondary">
              Sessions are conducted one-on-one or in small groups, depending on the work required.
            </p>
            <p className="body-medium text-secondary">
              This is not casual coaching. It is rigorous, focused work for those ready to engage with the method at depth.
            </p>
          </div>
        </div>
      </section>

      {/* Format */}
      <section className="py-20">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <h2 className="heading-2 mb-12">FORMAT & COMMITMENT</h2>
            <div className="space-y-8">
              <div>
                <h3 className="heading-5 mb-3 text-primary">Duration</h3>
                <p className="body-small text-secondary">
                  Coaching engagements typically run 3-6 months, with sessions scheduled based on availability and need.
                </p>
              </div>
              <div>
                <h3 className="heading-5 mb-3 text-primary">Location</h3>
                <p className="body-small text-secondary">
                  In-person sessions in London or Cairo, or remote sessions via secure video platform.
                </p>
              </div>
              <div>
                <h3 className="heading-5 mb-3 text-primary">Availability</h3>
                <p className="body-small text-secondary">
                  Private coaching places are limited. Availability is assessed on a case-by-case basis.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Who Should Apply */}
      <section className="py-20 bg-card">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <h2 className="heading-2 mb-8">WHO SHOULD APPLY</h2>
            <div className="space-y-6">
              <p className="body-medium">
                <span className="text-primary font-semibold">Professional actors</span> preparing for specific projects or requiring ongoing support in their practice.
              </p>
              <p className="body-medium">
                <span className="text-primary font-semibold">Coaches and teachers</span> seeking to deepen their understanding of the GPS Method™ or integrate it into their own practice.
              </p>
              <p className="body-medium">
                <span className="text-primary font-semibold">Established practitioners</span> from other disciplines who need structured guidance in presence-based work.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Important Notice */}
      <section className="py-20">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <div className="bg-card border border-primary p-8 rounded-sm">
              <div className="flex items-start gap-4">
                <AlertCircle size={24} className="text-primary flex-shrink-0 mt-1" />
                <div>
                  <h3 className="heading-5 mb-3 text-primary">Important</h3>
                  <p className="body-small mb-4">
                    Private coaching is application-based. Acceptance is not guaranteed.
                  </p>
                  <p className="body-small text-secondary">
                    We assess each request individually based on readiness, commitment, and alignment with the method. Response time is typically 5 business days.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-card">
        <div className="container-custom text-center">
          <h2 className="heading-3 mb-8 text-secondary">REQUEST PRIVATE COACHING</h2>
          <p className="body-medium mb-12 max-w-2xl mx-auto text-secondary">
            Submit your request below. Include your background, current practice, and why you're seeking this work.
          </p>
          <Link to="/apply" className="btn-primary inline-flex items-center">
            Submit Request
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Coaching;